import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AutomatedReviewTemplateValidation } from 'uplisting-frontend/validations';

export default class AutomatedReviewTemplateRepositoryService extends BaseRepositoryService<
  ModelRegistry['automated-review-template']
> {
  recordName = 'automated-review-template';
  implementMethods = ['findAll', 'createRecord', 'buildChangeset', 'unloadAll'];

  validation = AutomatedReviewTemplateValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/automated-review-template': AutomatedReviewTemplateRepositoryService;
  }
}
